import {
  // inject, onMounted, ref, watch,
  onMounted, ref,
} from 'vue';

const labelWidth = 110;

export default function useExpand(isDisabled) {
  const expand = ref(true);
  const showExpand = ref(false);
  const groupEl = ref(null);
  let expandEl;
  function changeExpand() {
    expand.value = !expand.value;
    setTimeout(() => {
      if (!expand.value && !isDisabled) {
        groupEl.value.style.height = `${46}px`;
        groupEl.value.querySelectorAll('.el-form-item__label').forEach((it) => {
          const item = it;
          item.style.width = 'auto';
        });
        // groupEl.value.style.height = `${expandEl.offsetTop - 1}px`;
      } else {
        groupEl.value.style.height = '';
        groupEl.value.querySelectorAll('.el-form-item__label').forEach((it) => {
          const item = it;
          item.style.width = `${labelWidth}px`;
        });
      }
    }, 0);
  }
  onMounted(() => {
    expandEl = groupEl.value.querySelector('.expand');
    expandEl?.remove();
    const form = groupEl.value.querySelector('form');
    setTimeout(() => {
      const items = Array.from(form.querySelectorAll('.el-form-item')).filter((it) => it.style.display !== 'none');
      // console.log(items.length * 356, form.offsetWidth);
      // labelWidth = items[0]?.querySelector('.el-form-item__label').offsetWidth;
      if (items.length * 356 > form.offsetWidth) {
        showExpand.value = true;
        changeExpand();
      } else {
        groupEl.value.querySelectorAll('.el-form-item__label').forEach((it) => {
          const item = it;
          item.style.width = 'auto';
        });
      }
    }, 0);
    // if (expandEl) {
    //   showExpand.value = true;

    //   watch(
    //     expand,
    //     (val) => {
    //       if (val) {
    //         expandEl.className = 'expand show';
    //       } else {
    //         expandEl.className = 'expand';
    //       }
    //     },
    //     {
    //       immediate: true,
    //     },
    //   );
    //   changeExpand();

    //   const useResized = inject('useResized');

    //   const resizeExpand = function resizeExpand() {
    //     if (!expand.value) {
    //       groupEl.value.style.height = `${expandEl.offsetTop - 1}px`;
    //     }
    //   };
    //   useResized(resizeExpand);
    // }
  });

  return {
    expand,
    showExpand,
    groupEl,
    changeExpand,
  };
}
